import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { css } from 'aphrodite';

import Button from './Button';
import Panels from './Panels';

import {
    fetchActions,
    filterActions
} from '../../../actions';

import { display } from '../../../../../commonStyles.js';
import styles from './styles.js';

const mapStateToProps = state => ({
    activeFilterGroupCollectionIndex: state.activeFilterGroupCollectionIndex,
    apiUrl: state.config.apiUrl,
    currencySymbol: state.searchObject.currency_symbol_left,
    filterGroups: state.filterGroups,
    lang: state.lang,
    searchParams: state.searchParams,
    trackingCookieId: state.config.trackingCookieId,
    userLang: state.config.userLang
});

const mapDispatchToProps = dispatch => ({
    applyFilterGroupCollection: (filterGroupCollection, filterGroupCollectionIndex) =>
        dispatch(filterActions.applyFilterGroupCollection(filterGroupCollection, filterGroupCollectionIndex)),
    fetchSearchResults: (apiUrl, userLang, location, tag, params, trackingCookieId) =>
        dispatch(fetchActions.fetchSearchResults(apiUrl, userLang, location, tag, params, trackingCookieId, true))
});

class FilterGroupCollection extends Component {
    static propTypes = {
        activeFilterGroupCollectionIndex: PropTypes.number.isRequired,
        apiUrl: PropTypes.string.isRequired,
        applyFilterGroupCollection: PropTypes.func.isRequired,
        currencySymbol: PropTypes.string,
        fetchSearchResults: PropTypes.func.isRequired,
        filterGroupCollection: PropTypes.object.isRequired,
        filterGroupCollectionIndex: PropTypes.number.isRequired,
        handleActiveFilterGroupCollection: PropTypes.func.isRequired,
        lang: PropTypes.object.isRequired,
        searchParams: PropTypes.object.isRequired,
        trackingCookieId: PropTypes.number.isRequired,
        updateFilterGroupCollection: PropTypes.func.isRequired,
        userLang: PropTypes.string.isRequired
    }

    render() {
        const {
            activeFilterGroupCollectionIndex,
            apiUrl,
            applyFilterGroupCollection,
            currencySymbol,
            fetchSearchResults,
            filterGroupCollection,
            filterGroupCollectionIndex,
            handleActiveFilterGroupCollection,
            lang,
            searchParams,
            trackingCookieId,
            updateFilterGroupCollection,
            userLang
        } = this.props;
        return (
            <span>
                <div className={css(display.inlineBlock)}>
                    <div className={css(styles.filterGroup)}>
                        <Button
                            activeFilterGroupCollectionIndex={activeFilterGroupCollectionIndex}
                            applyFilterGroupCollection={applyFilterGroupCollection}
                            filterGroupCollection={filterGroupCollection}
                            filterGroupCollectionIndex={filterGroupCollectionIndex}
                            handleActiveFilterGroupCollection={handleActiveFilterGroupCollection}
                        />
                        <div>
                            {Number(activeFilterGroupCollectionIndex) === Number(filterGroupCollectionIndex) ?
                                <Panels
                                    apiUrl={apiUrl}
                                    applyFilterGroupCollection={applyFilterGroupCollection}
                                    currencySymbol={currencySymbol}
                                    fetchSearchResults={fetchSearchResults}
                                    filterGroupCollection={filterGroupCollection}
                                    filterGroupCollectionIndex={filterGroupCollectionIndex}
                                    handleActiveFilterGroupCollection={handleActiveFilterGroupCollection}
                                    lang={lang}
                                    searchParams={searchParams}
                                    trackingCookieId={trackingCookieId}
                                    updateFilterGroupCollection={updateFilterGroupCollection}
                                    userLang={userLang}
                                /> : null
                            }
                        </div>
                    </div>
                </div>
            </span>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FilterGroupCollection);



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FilterBar/FilterGroupCollection/FilterGroupCollection.jsx